// ADR 30.9.26j §4 — a range you drag, owning its focus treatment, as every
// control does (8.9.26g AC3). The first user is the tutor's reading-position
// scrubber; the element takes a ref because that caller commits on the native
// `change` event, which React's `onChange` (the DOM `input` event) is not.

import { forwardRef, type InputHTMLAttributes } from 'react'

import { FOCUS_RING } from '../Button'

export type RangeSliderProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export const RangeSlider = forwardRef<HTMLInputElement, RangeSliderProps>(function RangeSlider(
  { className = '', ...props },
  ref,
) {
  return <input ref={ref} type="range" className={`accent-accent ${FOCUS_RING} ${className}`.trim()} {...props} />
})
